import { render, staticRenderFns } from "./DigiBoardSettingsDetails.vue?vue&type=template&id=5b82c4fa&scoped=true"
import script from "./DigiBoardSettingsDetails.vue?vue&type=script&lang=js"
export * from "./DigiBoardSettingsDetails.vue?vue&type=script&lang=js"
import style0 from "./DigiBoardSettingsDetails.vue?vue&type=style&index=0&id=5b82c4fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b82c4fa",
  null
  
)

export default component.exports